var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "info-form",
              staticStyle: { "margin-top": "22px" },
              attrs: { "label-width": "110px", model: _vm.form },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户头像", prop: "avatar" } },
                [
                  _c("img", {
                    staticStyle: { width: "128px", height: "128px" },
                    attrs: {
                      src: _vm.form.userAvatar
                        ? _vm.form.userAvatar
                        : require("../../../assets/icon_touxiang_106@2x.png"),
                    },
                  }),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户信息", prop: "name" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "line-height": "30px",
                        "margin-top": "4px",
                      },
                    },
                    [_vm._v(" 姓名：" + _vm._s(_vm.form.userName) + " ")]
                  ),
                  _c("div", { staticStyle: { "line-height": "30px" } }, [
                    _vm._v("ID：" + _vm._s(_vm.form.userId || "--")),
                  ]),
                  _c("div", { staticStyle: { "line-height": "30px" } }, [
                    _vm._v(
                      " 电话：" + _vm._s(_vm.form.userPhone || "--") + " "
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "下单时间", prop: "name" } },
                [_vm._v(" " + _vm._s(_vm.form.orderTime || "--") + " ")]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订单编号", prop: "name" } },
                [_vm._v(" " + _vm._s(_vm.form.orderNo || "--") + " ")]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称", prop: "goods" } },
                [_vm._v(" " + _vm._s(_vm.form.goodsName) + " ")]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品规格", prop: "sku" } },
                [_vm._v(" " + _vm._s(_vm.form.goodsSkuName) + " ")]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "评论星数", prop: "star" } },
                [_vm._v(" " + _vm._s(_vm.form.starLabel) + " ")]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "评论内容", prop: "content" } },
                [
                  _c("div", { staticStyle: { width: "50%" } }, [
                    _vm._v(" " + _vm._s(_vm.form.content) + " "),
                  ]),
                ]
              ),
              _c("el-form-item", { attrs: { label: "评论图片" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "margin-top": "12px" } },
                  _vm._l(_vm.form.imgList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item + index,
                        staticClass: "itemI",
                        staticStyle: { "margin-left": "8px" },
                      },
                      [
                        _c("el-image", {
                          staticStyle: {
                            width: "108px",
                            height: "108px",
                            "border-radius": "6px",
                          },
                          attrs: { src: item },
                          on: {
                            click: function ($event) {
                              return _vm.look(item)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _c("el-form-item", { attrs: { label: "状态", prop: "status" } }, [
                _vm.form.showFlag == true
                  ? _c("span", [_vm._v("显示")])
                  : _vm._e(),
                _vm.form.showFlag == false
                  ? _c("span", [_vm._v("隐藏")])
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _c("div", { staticStyle: { height: "20px" } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "back-btn" },
        [
          _c(
            "el-button",
            { attrs: { type: "info" }, on: { click: _vm.back } },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: {
              width: "100%",
              fit: "contain",
              src: _vm.dialogImageUrl,
              alt: "",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }